import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
// import search from "./images/search.png";
import $ from "jquery";
import { MdMenu, MdClose } from "react-icons/md";
import logo1 from './images/logo2eee.png'
import { useMediaQuery } from "@mui/material";
import { NavbarMobile } from "./navbar-mobile";
import { CgProfile } from 'react-icons/cg'

const Navbar = (props) => {
  const [showMobileMenuWidth, setMobileMenuWidth] = useState("0")
  const isMobile = useMediaQuery("(max-width: 1024px)")
  const [showMobileMenu, setShowMobileMenu] = useState(false); //toggle mobile menu
  const links = [
    { name: "Home", to: "home" },
    // { name: "Find a dog", to: "community" },
    { name: "Breeds", to: "/breeds" },

    { name: "Register a dog", to: "registration", id: "navbarDropdownMenuLink" },
    { name: "Sign Up", to: "sign_up" },
    { name: "Login", to: "login", onClick: props.toggle_login },
  ];

  useEffect(() => {
    if (window.screen.width < 660) {
      console.log(window.location);
      if (window.location.pathname.split("/").includes("my_dogs")) {
        console.log("hide the following");
        $(".nav-link").css("color", "white");

        $("nav").addClass("navbar-dark");

        $(".navtitle").css("color", "white");
      } else {
        console.log("cnahging");
      }
    }
  }, [window.screen.width]);

  useEffect(() => {
    if (showMobileMenu == true) {
      setMobileMenuWidth("80%")
    }
    if (showMobileMenu == false) {
      setMobileMenuWidth("0%")
    }
  }, [showMobileMenu])

  return (
    <div
      class="row  position-sticky align-content-center justify-content-center
              w-100 "
      style={{ zIndex: "30" }}
    >
      {/* <span className='navtitle font-weight-bold' style={{ color: props.color }}>THE AFRICAN BULLY REGISTRY</span> */}

      <div className="w-100">
        <nav
          class={`navbar navbar-light navbar-expand-lg ${props.navbar_dark}`}
        >
          <Link class="navbar-brand " to="">
            <img src={logo1} height="45px" width="45px" alt="logo" />
          </Link>

          {!isMobile && <div
            class="w-100 align-items-center justify-content-center navbar"
            id="navbarNavDropdown"
          >
            <ul className="navbar-nav text-center d-none ">
              <li className="nav-item active" style={{ color: props.color }}>
                <span className="navtitle" style={{ color: props.color }}>
                  THE AFRICAN BULLY REGISTRY
                </span>
              </li>
            </ul>
            <ul class="navbar-nav ml-auto">
              {links.map(({ name, to, id, onClick }) => {
                return (
                  <li class="nav-item active">
                    <Link
                      class="nav-link"
                      style={{ color: props.color }}
                      to={`/${to}`}
                      id={id}
                      onClick={onClick}
                    >
                      {name}
                    </Link>

                  </li>
                );
              })}
              <div>
                <Link to={'/profile'}>
                  <CgProfile size={24} color="black" />

                </Link>              </div>

              <li class="nav-item active">
                <Link
                  class="nav-link"
                  style={{ color: props.color }}
                  to="/search-page"
                >
                  <i
                    class="fa fa-search p-0 m-0"
                    style={{ "font-size": "15px", width: "10px" }}
                  ></i>
                </Link>

                {/* Add a tooltip to this place */}
              </li>
            </ul>
          </div>}
          <MdMenu
            size={32}
            color="black"
            style={{ cursor: "pointer" }}
            className="afbr_icon-menu"
            // className=" d-block d-sm-none d-md-none"
            onClick={() => setShowMobileMenu((init) => !init)}
          />
          <NavbarMobile
            showMobileMenu={showMobileMenu}
            setShowMobileMenu={setShowMobileMenu}
            showMobileMenuWidth={showMobileMenuWidth}
            width={showMobileMenuWidth} />
        </nav>
      </div>
    </div>
  );
};

export default Navbar;
